import { UPDATE_ACCOUNT_DETAILS, UPDATE_ACCOUNT_DETAILS_DONE, UPDATE_ACCOUNT_DETAILS_ERROR, UPDATE_ACCOUNT_DETAILS_RESET } from './actionTypes';
export const updateAccountDetails = (data) => ({
    type: UPDATE_ACCOUNT_DETAILS,
    data
});
export const updateAccountDetailsDone = (data) => ({
    type: UPDATE_ACCOUNT_DETAILS_DONE,
    data
});
export const updateAccountDetailsError = (data) => ({
    type: UPDATE_ACCOUNT_DETAILS_ERROR,
    data
});
export const updateAccountDetailsReset = () => ({
    type: UPDATE_ACCOUNT_DETAILS_RESET
});
//# sourceMappingURL=actionCreators.js.map